import { render, staticRenderFns } from "./PagoCard.vue?vue&type=template&id=45f6448f&"
import script from "./PagoCard.vue?vue&type=script&lang=js&"
export * from "./PagoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports